import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from "./../service";
import { UserInfo, UserService } from '../service/user.service';
import { map, take } from 'rxjs/operators';
import { Roles } from 'src/app/model';

@Injectable({
  providedIn: 'root'
})

export class RoleGuard implements CanActivate {
  private roles = Roles;

  constructor(private _auth :AuthenticationService, private _router: Router, private userService: UserService) {
  }
  
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree > | boolean | UrlTree {
    return this.userService.userInfo$.pipe(take(1),map((userInfo: UserInfo) => {
      const requiredRoles = next.data.rolUsuario;
      const userRole: number | null = userInfo.rol; 
      const hasPermission = requiredRoles.some((requiredRole) => requiredRole === userRole);
      if (hasPermission) {
        return true;
      } else {
        console.warn(
          `Access denied for role: ${userRole}. Required roles: ${requiredRoles.join(', ')}`
        );
        return this._router.createUrlTree(['/peticiones/seguimiento']);
      }
    }));
  }
}
